import * as THREE from "three";
import Experience from "../Experience.js";

export default class Lamp {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("Lamp");
    }

    // Resource
    this.resource = this.resources.items.lampModel;

    this.setModel();
    this.setLampLight();
  }

  setModel() {
    this.model = this.resource.scene;
    this.model.position.set(1.36, -0.35, 0.27);
    this.model.rotateY(-0.5);
    this.model.name = "lamp";

    this.scene.add(this.model);

    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.name = this.model.name;
      }
    });
  }

  setLampLight() {

    //Light Target
    this.lightTarget = new THREE.Object3D();
    this.lightTarget.position.set(1.32, -0.37, 0.42);
    this.scene.add(this.lightTarget);
  
    this.lampLight = new THREE.SpotLight("#FCFDC3");
    this.lampLight.distance = 2;
    this.lampLight.shadow.mapSize.set(1024, 1024);
    this.lampLight.shadow.radius = 10;
    this.lampLight.castShadow = true;
    this.lampLight.angle = Math.PI / 4;
    this.lampLight.target = this.lightTarget;
    this.lampLight.shadow.camera.far = 2;
    this.lampLight.shadow.normalBias = 0.05;
    this.lampLight.position.set(1.37, -0.17, 0.32);
    this.scene.add(this.lampLight);
  }
}
